import { Button, useDisclosure } from "@heroui/react";
import { AcceptTokenButton } from "../components/dev/AcceptTokenButton";
import { NewL1TokenButton } from "../components/dev/NewL1TokenButton";
import { ProposeTokenModal } from "../components/tokens/ProposeTokenModal";
import { ProposeTokenSuccessModal } from "../components/tokens/ProposeTokenModalSuccess";
import { TokeRegTable } from "../components/tokens/TokeRegTable";

export default function TokensRoute() {
  const proposeModalDisclosure = useDisclosure();
  const proposeModalSuccessDisclosure = useDisclosure();

  return (
    <div className="max-w-screen-xl mx-auto mt-8 p-4 grid grid-cols-12 gap-x-4 gap-y-8">
      <div className="flex flex-col gap-4 col-span-6">
        <h1 className="font-['Krona_One'] text-4xl">Tokens</h1>

        <p className="text-[#849AA9] text-sm font-medium">
          Shielding is the process during which the balance of your token, which is public, becomes private, as a result
          of it.
        </p>
      </div>

      <div className="col-span-6 self-center justify-self-end inline-flex gap-4 items-center">
        <NewL1TokenButton />
        <AcceptTokenButton />

        <Button color="primary" radius="full" size="lg" onPress={proposeModalDisclosure.onOpen}>
          Propose Token
        </Button>
      </div>

      <TokeRegTable />

      <ProposeTokenModal
        isOpen={proposeModalDisclosure.isOpen}
        onClose={proposeModalDisclosure.onClose}
        onSuccess={() => {
          proposeModalDisclosure.onClose();
          proposeModalSuccessDisclosure.onOpen();
        }}
      />

      <ProposeTokenSuccessModal
        isOpen={proposeModalSuccessDisclosure.isOpen}
        onClose={proposeModalSuccessDisclosure.onClose}
      />
    </div>
  );
}
